/* eslint-disable */
import { DOCKETS_LIST_SETTINGS } from './Dockets.types';

/**
 * Create the state for the `docketsReducer` before `redux-persist` kicks in
 * @returns {any} The initial state before `redux-persist` kicks in
 */
const createPrePersistDocketsState = () => ({
  listSettings: null,
});

/**
 * Create the `docketsReducer`
 * @param {InjectablesForReducer} injectables The _injectable_'s required by this reducer
 * @returns {Reducer<State, DocketsActions>} The `docketsReducer`
 */
const docketsReducer = () => (state = createPrePersistDocketsState(), action) => {
  switch (action.type) {
    case DOCKETS_LIST_SETTINGS: {
      return {
        ...state,
        listSettings: { ...state.listSettings, ...action.payload },
      };
    }
    default: {
      return state;
    }
  }
};

export default docketsReducer;
